// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
var define;
var is_node = typeof module=='object' && module.exports;
if (is_node)
    define = require('../../../../util/require_node.js').define(module, '..');
else
    define = self.define;
define([], ()=>{
const E = {};
E.intro = [['div',
    [['h1',
        [`Hola Dictionary`],
        {className: `title`},
    ],
    ['p',
        [['b',
            [`What does XXX mean?`],
        ],
        ` On your way becoming `,
        ['a',
            [`Hola Veteran`],
            {href: `#veteran`},
        ],
        ` you will hear many terms, see many systems, have to understand a
            lot of Hola internal lingo.`,
        ['br'],
        ` What does 'fix the `,
        ['a',
            [`BAT`],
            {href: `#bat`},
        ],
        `' mean? What is 'request a ccgi-b `,
        ['a',
            [`deploy`],
            {href: `#deploy`},
        ],
        `'? Here are the answers! `],
    ],
    ['p',
        [` Improvements? Suggestions? email `,
        ['a',
            [`dna@hola.org`],
            {href: `mailto:dna@hola.org`},
        ],
        ` `],
    ]],
    {className: `head`},
]];
E.data = [
    {
        id: 'dict',
        title: '',
        tag: 'h2',
        html: [],
        short: 'Hola Dictionary',
    },
    {
        id: 'bat',
        title: `Build and Test (BAT): continuous integration`,
        tag: 'h3',
        short: `BAT`,
        html: [['p',
            [['a',
                [`BAT webpage`],
                {href: `http://bat.hola.org`,
                    'data-toggle': `tooltip`,
                    'data-placement': `top`,
                    title: ``,
                    'data-original-title':
                        `Link to internal Hola site (not public).`},
            ],
            ['br'],
            ` Originally built at `,
            ['a',
                [`Jungo`],
                {href: `#jungo`},
            ],
            ` in 2001, and has been constantly upgraded and improved ever
                since. `],
        ],
        ['ul',
            [['li',
                [`checkout: cvs co`],
            ],
            ['li',
                [`make: jake build system, compiling and building images`],
            ],
            ['li',
                [`lint: `,
                ['a',
                    [`js/json/perl/html/css`],
                    {href: `#zlint`},
                ]],
            ],
            ['li',
                [`unit-test: `,
                ['a',
                    [`js (zmocha)`],
                    {href: `#zmocha`},
                ],
                `/C (jtest)`],
            ],
            ['li',
                [`upload: uploading results and images to `,
                ['a',
                    [`fs`],
                    {href: `#fs`},
                ]],
            ]],
        ]],
    },
    {
        id: 'bat-colors',
        title: `BAT colors`,
        tag: 'h4',
        short: `BAT colors`,
        html: [['ul',
            [['li',
                [`GREEN - build and unit-tests passed successfully`],
            ],
            ['li',
                [`ORANGE - build passed, but unit-test failed`],
            ],
            ['li',
                [`YELLOW - build passed, but unit-test identified memory
                    leak`],
            ],
            ['li',
                [`RED - build failed`],
            ],
            ['li',
                [`White strips background indicates a BAT request cycle`],
            ]],
        ]],
    },
    {
        id: 'bat-broken',
        title: `What happen when BAT is broken?`,
        tag: 'h4',
        short: `BAT is broken`,
        html: [['ul',
            [['li',
                [` You don't necessarily have to fix it yourself;`,
                ['br'],
                ` If possible, find out whose commit broke it and get them
                    to fix it.`,
                ['br'],
                ` Don't assume they already know it's broken.`,
                ['br'],
                ` If it's a simple fix - fix it yourself `],
            ],
            ['li',
                [`If you have to fix after someone else broke BAT, add that
                    person to the commit message using `,
                ['dfn',
                    [`NOTIFY:`],
                ]],
            ],
            ['li',
                [`If it's not easy to fix (requires thinking/debugging/cannot
                    be fixed in 1 minute), revert the offending commit and
                    notify whoever made it`],
            ],
            ['li',
                [` Alternatively, if unit-test fails, disable the individual
                    test using `,
                ['code',
                    [`if (0) // XXX person`],
                ],
                `.`,
                ['br'],
                ` Use your judgment as to when to revert and when to disable
                    the test.`,
                ['br'],
                ` Disable when you know that the test itself is the problem,
                    or that the breakage is not mission-critical. Always
                    notify the person responsible for fixing the test. `],
            ]],
        ]],
    },
    {
        id: 'mdoc',
        title: `Mongo Documents (Mdoc): our crm`,
        tag: 'h3',
        short: `Mdoc`,
        html: [['p',
            [['a',
                [`Mdoc webpage`],
                {href: `http://mdoc.hola.org`},
            ],
            ['br'],
            ` Originally built to control the `,
            ['a',
                [`Deploy`],
                {href: `#deploy`},
            ],
            ` work flow, it quickly expanded to hold most of our procedures
                for R&D, Deploy, sales, IT and HR.`,
            ['br'],
            ` The system is based on a mongo collection that stores data per
                every procedure. This allows us to control, verify, and
                investigate procedures, which we do daily. `],
        ]],
    },
    {
        id: 'mdoc-worlds',
        title: `Mdoc worlds`,
        tag: 'h4',
        html: [['ul',
            [['li',
                [`Deploy - holds all the deploy procedures related to
                    deploying new versions of our products and servers`],
            ],
            ['li',
                [`CDN/Lum - holds all the CDN/Bright Data customers leads and
                    specific procedures executed in this department`],
            ],
            ['li',
                [`R&D - holds all the R&D training procedures`],
            ],
            ['li',
                [`IT - holds all the IT installation procedures`],
            ],
            ['li',
                [`HR - holds all our candidates files`],
            ]],
        ]],
    },
    {
        id: 'jdoc',
        title: `Jdoc notification system`,
        tag: 'h3',
        short: `Jdoc`,
        html: [['p',
            [` Jdoc stands for 'Jungo documents', and was originally built at
                `,
            ['a',
                [`Jungo`],
                {href: `#jungo`},
            ],
            ` in 2001.`,
            ['br'],
            ` The jdoc mechanism allows you, or anyone interested, to
                register notifications for a specific file or directory's
                content, based on our `,
            ['a',
                [`CVS`],
                {href: `#cvs`},
            ],
            `, and review every single commit.`,
            ['br'],
            ` The jdoc file is located at the root directory of our
                development tree.`,
            ['br'],
            ` This notification mechanism is being used to implement our `,
            ['a',
                [`async Review`],
                {href: `#review-async`},
            ],
            ` and to support the co-ownership of a module or a file, by
                sending emails for every modification made to the file or
                directory's content. Note that you may use the `,
            ['code',
                [`NOTIFY:`],
            ],
            ` statement, in every commit you do, to manually activate this
                notification system for specific logins (people in Hola) you
                want to notify. `],
        ],
        ['pre',
            [`NOTIFY: colin
added 'eval' to dropdown list
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`added 'eval' to dropdown list
NOTIFY: colin
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [` In case you would like to cancel the notification for the
                commit you are about to do, since your change is cosmetic or
                not important, use `,
            ['code',
                [`NOTIFY: cancel`],
            ],
            ` in the commit message. `],
        ]],
    },
    {
        id: 'review',
        title: `Peer Review: keeping our code quality
  top-notch`,
        tag: 'h3',
        short: `Review`,
        html: [['p',
            [` Writing code is our profession, keeping it top-notch is our
                pleasure!`,
            ['br'],
            ` As it's the main form of communication between the team,
                having our codebase perfectly consistent in style makes it
                easy for developers to read and modify each other's code.`,
            ['br'],
            ` So, to increase the team's efficiency, we invest time in
                teaching everyone how to write code. The review process is
                our main tool for doing so. `],
        ]],
    },
    {
        id: 'review-sync',
        title: `Blocking sync Review: first review, then
  commit`,
        tag: 'h4',
        short: `Sync`,
        html: [['p',
            [` During the `,
            ['a',
                [`bootcamp`],
                {href: `#bootcamp`},
            ],
            ` and even few weeks after, your code will be reviewed by your `,
            ['a',
                [`mentor`],
                {href: `#mentor`},
            ],
            ` in order to provide you with all the tools and guidelines on
                how we write our code. During this period, you'll do commit
                sessions together with your mentor until he is fully
                convinced you are prepared to write code like everybody else
                in Hola and commit it on your own.`,
            ['br'],
            ` It's your responsibility to commit your code, and hence, you
                will probably call your mentor for a commit session once you
                are done with your task.`,
            ['br']],
        ]],
    },
    {
        id: 'review-sync-precommit',
        title: `Pre-commit
  checklist`,
        tag: 'h5',
        short: `Pre-commit checklist`,
        html: [['p',
            [` You probably ask yourself what the mentor is checking during
                this session and whether your code is ready?`,
            ['br'],
            ` Below is the checklist you need to do before answering
                yourself if your code is ready for a commit session: `],
        ],
        ['ul',
            [['li',
                [`Verify that all editors are closed before committing the
                    code`],
            ],
            ['li',
                [`Do `,
                ['code',
                    [`cvsup -A`],
                ],
                ` on the root directory`],
            ],
            ['ul',
                [['li',
                    [` Make sure all new files were added to the cvs using `,
                    ['code',
                        [`cvs add FILENAME`],
                    ],
                    ` (verify no new files marked with `,
                    ['code',
                        [`?`],
                    ],
                    ` exist).`,
                    ['br']],
                ],
                ['li',
                    [` Verify that all modified (`,
                    ['code',
                        [`M`],
                    ],
                    `) files are files you want to commit.`,
                    ['br'],
                    ` If there are files you want to commit later, duplicate
                        the tree `,
                    ['code',
                        [`cp -a zon1 zon1.new`],
                    ],
                    `, and make the current tree include exactly what you
                        are going to commit. `],
                ]],
            ],
            ['li',
                [` Run `,
                ['code',
                    [`zlint -m`],
                ],
                ` from the root directory (use `,
                ['code',
                    [`cdr`],
                ],
                ` to move to the root directory). `],
            ],
            ['li',
                [['a',
                    [`Coding conventions`],
                    {href: `#coding`},
                ],
                `: re-read the code, and validate it is compliant. Noobs can
                    use `,
                ['code',
                    [`zlint -cm`],
                ],
                ` tool to assist `,
                ['a',
                    [`locating convention mistakes`],
                    {href: `/dna/js_code#overview-tool`},
                ],
                ` (the tool is only 95% accurate - so you still must know
                    all the rules!). `],
            ],
            ['li',
                [` Run `,
                ['code',
                    [`zdiff`],
                ],
                ` and re-check all your changes. Validate there are no
                    'debug leftovers' (console.log()...). `],
            ],
            ['li',
                [` Its OK to do a `,
                ['a',
                    [`partial solution/implementation`],
                    {href: `/dna#incremental-mvp`},
                ],
                `, but in such cases `,
                ['a',
                    [`comment in the code`],
                    {href: `/dna/js_code#comment-xxx`},
                ],
                `, or add to the `,
                ['a',
                    [`version_plan`],
                    {href: `#version_plan`},
                ],
                ` a description of what `,
                ['a',
                    [`you will do later`],
                    {href: `/dna#individual-solve-half`},
                ],
                `. `],
            ],
            ['li',
                [`If this is a modification/removal, `,
                ['a',
                    [`rgrep`],
                    {href: `#rgrep`},
                ],
                ` the whole tree to validate all related code is modified
                    accordingly`],
            ],
            ['li',
                [`Run all the `,
                ['a',
                    [`unit-tests`],
                    {href: `#zmocha`},
                ],
                ` from the root directory`],
            ],
            ['li',
                [`Make sure the tree can compile (`,
                ['code',
                    [`jmake cm release`],
                ],
                `)`],
            ],
            ['li',
                [`Test the feature and play with it in `,
                ['a',
                    [`zlxc`],
                    {href: `#zlxc`},
                ]],
            ],
            ['li',
                [` Open questions? not perfect? not 100% ready for commit
                    as-is? then `,
                ['a',
                    [`don't call your mentor for a commit session`],
                    {href: `/dna#individual-noharm-peer`},
                ],
                `.`,
                ['br'],
                ` Rather, prepare all the list of questions in an editor,
                    with your `,
                ['a',
                    [`suggested solutions`],
                    {href: `/dna#individual-owner-complain`},
                ],
                `, and call your mentor for a Q&A session.`,
                ['br'],
                ` Later on, once your questions have been answered, and you
                    code is perfect, call your mentor for a commit session.
                    `],
            ]],
        ]],
    },
    {
        id: 'review-sync-committing',
        title: `Committing`,
        tag: 'h5',
        html: [['p',
            [`Commit only the files you want to commit`],
        ],
        ['pre',
            [`cvs ci
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`cvs ci file1.js file2.js file3.js
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'review-sync-commit_msg',
        title: `Commit message`,
        tag: 'h5',
        html: [['p',
            [`Short, simple and descriptive - `,
            ['a',
                [`be minimalistic`],
                {href: `/dna#effective-minimal`},
            ]],
        ],
        ['pre',
            [`fix mistake in passing of video url in opts from zone_init to zone_find
and converting opt.url to opt.video_url
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`move zone_init to zone_find and convert opt.url to opt.video_url
`],
            {className: `cm-s-default code ok  has-popover`,
                cat: `ok`,
                'data-content': `OK`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`zone_init -> zone_find
opt.url -> opt.video_url
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`Start with small letter`],
        ],
        ['pre',
            [`Update tasks
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`update tasks
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`When doing a sync review add your reviewer login in brackets`],
        ],
        ['pre',
            [`fixed conventions (nir)
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`Do not include the filename you committed to in the message -
                it is redundant`],
        ],
        ['pre',
            [`fixed conventions in agent_conf.js
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`fixed conventions
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [
`If commit is related to a task, include link in the commit message`
            ],
        ],
        ['pre',
            [`fixed layout
TASK: https://brightdata-group.monday.com/boards/12345/pulses/67890
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]]
    },
    {
        id: 'review-sync-redo',
        title: `Redo your code for a commit
  session`,
        tag: 'h5',
        short: `Redo commit`,
        html: [['p',
            [` You may call your mentor for questioning session. This is more
                than welcome and even recommended during the bootcamp.
                However, once calling your mentor for a commit session the
                expectation is that you did your best to comply with `,
            ['b',
                [`ALL`],
            ],
            ` `,
            ['a',
                [`pre-commit checks`],
                {href: `#review-sync-precommit`},
            ],
            `. It means that all open questions have been looked up deeply
                and resolved, and your code is bright and shining, waiting
                to be sent out to our million of users.`,
            ['br'],
            ` In Hola we `,
            ['a',
                [`respect other's time`],
                {href: `/dna#individual-mindful`},
            ],
            `, calling your mentor for a commit session which ended up with
                a "redo", is a completely waste of time.`,
            ['br'],
            ` Make sure you meet this expectation. Take very seriously the
                remarks you received, and try to find out how to improve
                your personal commit procedures not to repeat these mistakes
                next time. `],
        ]],
    },
    {
        id: 'review-sync-postcommit',
        title: `Post-commit
  checklist`,
        tag: 'h5',
        short: `Post-commit checklist`,
        html: [['p',
            [`Now, after you have committed your code, below is the checklist
                you need to do after your commit:`],
        ],
        ['ul',
            [['li',
                [`Run `,
                ['code',
                    [`cvsup`],
                ],
                ` and make sure the tree is fully committed (no `,
                ['code',
                    [`M`],
                ],
                `, nor `,
                ['code',
                    [`?`],
                ],
                ` files)`],
            ],
            ['li',
                [`Check `,
                ['a',
                    [`BAT`],
                    {href: `#bat`},
                ],
                ` until you see your commit got compiled and tested green`],
            ],
            ['li',
                [`If BAT is broken, `,
                ['a',
                    [`make it green again`],
                    {href: `#bat-broken`},
                ],
                ` by fixing the problem`],
            ],
            ['li',
                [`Deploy your code - bring value!`],
            ],
            ['ul',
                [['li',
                    [` Deploy your code immediately. Worse case, in case it
                        is after `,
                    ['a',
                        [`working hours`],
                        {href: `#attendance`},
                    ],
                    `, ask for a pending release in the morning `],
                ],
                ['li',
                    [`Track it immediately, or after deployment (60 seconds
                        manual test after deployment, kibana, stats)`],
                ]],
            ]],
        ]],
    },
    {
        id: 'review-async',
        title: `Non-blocking async Review: first commit, and
  later others will review`,
        tag: 'h4',
        short: `Async`,
        html: [['p',
            [` Once passing the stage of `,
            ['a',
                [`blocking review`],
                {href: `#review-sync`},
            ],
            ` you'll start committing your code on your own.`,
            ['br'],
            ` This time, the review will be done by co-owners of the code
                you changed or by other engineers who are registered on the
                files you have modified (using the `,
            ['a',
                [`jdoc`],
                {href: `#jdoc`},
            ],
            ` system). `],
        ]],
    },
    {
        id: 'fs',
        title: `FS: Central shared filesystem`,
        tag: 'h3',
        short: `FS`,
        html: [['p',
            [['a',
                [`text missing: contribution welcome!`],
                {href: `mailto:dna@hola.org`},
            ]],
        ]],
    },
    {
        id: 'jungo',
        title: `Jungo: Our origin: Passion for complex networking
  and a love for Open Source`,
        tag: 'h3',
        short: `Jungo`,
        html: [['p',
            [['a',
                [`text missing: contribution welcome!`],
                {href: `mailto:dna@hola.org`},
            ]],
        ]],
    },
    {
        id: 'rgrep',
        title: `rgrep: recursive grep`,
        tag: 'h3',
        short: `rgrep`,
        html: [['p',
            [` grep is an amazing tool. Just like you google the Internet for
                answers on public info, you grep source code for answers on
                our private tree.`,
            ['br'],
            ['code',
                [`rgrep`],
            ],
            ` is our recursive grep, with a few little usability
                improvements: `],
        ],
        ['ul',
            [['li',
                [`Scans by default all files in the tree, recursively`],
            ],
            ['li',
                [`Skips version controlled meta-files, editor temporary files
                    (swp, bak, ...), and build output directory`],
            ],
            ['li',
                [`Allows language selection, such as `,
                ['code',
                    [`rgrep --js send_msg`],
                ],
                ` will only search *.js files for send_msg string`],
            ]],
        ],
        ['p',
            [` We recommended to always `,
            ['code',
                [`rgrep`],
            ],
            ` from the root directory. This will ensure you never miss a
                reference.`,
            ['br'],
            ['code',
                [`rgrep`],
            ],
            ` is installed on your machine as part of our development
                environment. `],
        ]],
    },
    {
        id: 'zlint',
        title: `zlint: general purpose linter`,
        tag: 'h3',
        short: `zlint`,
        html: [['p',
            [` Can lint many types of files: js, json, perl, html, css and
                more. Always run it before commit.`,
            ['br'],
            ['code',
                [`zlint`],
            ],
            ` is installed on your machine as part of our development
                environment. `],
        ]],
    },
    {
        id: 'capture',
        title: `Screen capture`,
        tag: 'h3',
        html: [['p',
            [` When reporting bugs, requesting UI related tasks, or
                completing UI related tasks, add a minimal (cropped) screen
                capture or animated GIF to your report demonstrating the
                item or modification you did. Also, mark in it where the
                change is so it will be easy for the other side reviewing it
                and respond quickly.`,
            ['br'],
            ` An example of a cropped, tiny marked screenshot: `],
        ],
        ['p',
            [['img',
                [],
            ]],
        ],
        ['p',
            [` Implementing the above can be done by using applications such
                as `,
            ['a',
                [`FastStone`],
                {href: `http://www.faststone.org/FSCapturerDownload.htm`},
            ],
            ` for static screenshots, or `,
            ['a',
                [`ScreenToGIF`],
                {href: `http://www.screentogif.com/`},
            ],
            ` for animated GIFs. `],
        ]],
    },
    {
        id: 'zmocha',
        title: `zmocha: mocha based JS unit-testing tool`,
        tag: 'h3',
        short: `zmocha`,
        html: [['p',
            [` Our unit-test framework is based on `,
            ['a',
                [`mocha`],
                {href: `https://mochajs.org`},
            ],
            `. Every new function deserves a unit-test to make sure further
                development will not affect current behavior.`,
            ['br'],
            ` One of the most efficient ways of testing your code
                modifications is running unit-tests on the whole development
                tree by executing `,
            ['code',
                [`jmake run_tests`],
            ],
            `.`,
            ['br'],
            ` Running tests on a specific directory can be done by running `,
            ['code',
                [`zmocha`],
            ],
            ` within the directory.`,
            ['br'],
            ` Running specific test in a specific directory can be done by `,
            ['code',
                [`zmocha -g [test]`],
            ]],
        ]],
    },
    {
        id: 'zupdate',
        title: `zupdate: Updating your development environment
  and tools`,
        tag: 'h3',
        short: `zupdate`,
        html: [['p',
            [['code',
                [`zupdate`],
            ],
            ` is a command line that will install and update your
                development environment, based on your `,
            ['code',
                [`.zon`],
            ],
            ` tree (this is the reason why we keep `,
            ['code',
                [`.zon`],
            ],
            ` untouched and unmodified).`,
            ['br'],
            ` The development environment holds the `,
            ['a',
                [`gvim`],
                {href: `#gvim`},
            ],
            ` definition and themes, VM look&feel and all required
                development tools.`,
            ['br'],
            ` It is recommended to run `,
            ['code',
                [`zupdate`],
            ],
            ` every day, as our codebase is changing rapidly together with
                our development environment and tools.`,
            ['br']],
        ]],
    },
    {
        id: 'gvim',
        title: `gVim: text editor`,
        tag: 'h3',
        short: `gVim`,
        html: [['p',
            [` Our common text editor based on `,
            ['a',
                [`Vim`],
                {href: `http://www.vim.org/about.php`},
            ],
            `, powered with many vim plugins that enhance our development
                productivity, and used as our code IDE.`,
            ['br'],
            ` Why are we using gVim?`,
            ['br'],
            ` Because it is tidily connected to our development environment
                and tools.`,
            ['br'],
            ` Can I use any other IDE instead?`,
            ['br'],
            ` Sure! You may use any IDE you like, just keep in mind that our
                gVim is already adjusted to our coding conventions and has
                many features to support our way of development. Your IDE
                should be adjusted as well.`,
            ['br'],
            ` Moreover, when working with other developers, they mostly
                would like to work on gVim, so you'll have to adjust
                yourself to it.`,
            ['br'],
            ` Do you have a shortcut for using gVim in your development
                environment?`,
            ['br'],
            ` Just use `,
            ['code',
                [`g`],
            ],
            `. It will open the gVim editor on your machine. More shortcuts
                and useful commands are in our `,
            ['a',
                [`vi Basic`],
                {href: `/dna/basics/vi`},
            ],
            ` page. `],
        ]],
    },
    {
        id: 'cvs',
        title: `CVS: Concurrent Version System`,
        tag: 'h3',
        short: `CVS`,
        html: [['p',
            [` Our source control plays a major role in daily inter-developer
                communication tool in the company.`,
            ['br'],
            ` Commits are also a form of email, being one of the core
                engines behind our module ownership and `,
            ['a',
                [`code reviews`],
                {href: `#review-async`},
            ],
            `.`,
            ['br'],
            ` Our version of CVS, originally based on the open source CVS,
                has been greatly enhanced and improved over the years to
                provide: `],
        ],
        ['ul',
            [['li',
                [`transparent offline support (via local smart cache proxy)`],
            ],
            ['li',
                [`instant checkout and update (via background prefetching)`],
            ],
            ['li',
                [`remote web interface, GitHub like`],
            ],
            ['li',
                [`local web interface, similar to other version control GUI
                    clients`],
            ],
            ['li',
                [` MD5_CDN signature based smart annotate: find out who `,
                ['b',
                    [`really`],
                ],
                ` originally wrote a function, no matter if it was copied,
                    or indentation has been changed. `],
            ],
            ['li',
                [`commit hooks: committing directly activates many different
                    deployment tasks, updating thousands of servers,
                    configuration, and code - instantly. `],
            ]],
        ],
        ['p',
            [`For a quick start, look at `,
            ['a',
                [`CVS basic command`],
                {href: `/dna/basics/cvs#basic`},
            ]],
        ]],
    },
    {
        id: 'cvsed',
        title: `cvsed: utility for editing and committing common
  files`,
        tag: 'h3',
        short: `cvsed`,
        html: [['p',
            [` An editor tool which combines editing a file using `,
            ['a',
                [`gvim`],
                {href: `#gvim`},
            ],
            `, and committing capabilities, using `,
            ['a',
                [`cvs`],
                {href: `#cvs`},
            ],
            ` update and commit commands.`,
            ['br'],
            ['code',
                [`cvsed`],
            ],
            ` has shortcuts to our most common used files, which can be seen
                by executing `,
            ['code',
                [`cvsed --help`],
            ],
            `.`,
            ['br'],
            ` You may use this tool for editing your `,
            ['a',
                [`daily`],
                {href: `#daily`},
            ],
            ` file (`,
            ['code',
                [`cvsed daily`],
            ],
            `) or your `,
            ['a',
                [`version plan`],
                {href: `#version_plan`},
            ],
            ` (`,
            ['code',
                [`cvsed vp`],
            ],
            `) or simply open both (`,
            ['code',
                [`cvsed vpd`],
            ],
            `). `],
        ]],
    },
    {
        id: 'zlxc',
        title: `zlxc: emulate everything in your PC`,
        tag: 'h3',
        short: `zlxc`,
        html: [['p',
            [` A staging environment is a great tool for developers: they can
                play around with the feature they developed in a 'full
                system', with all the hundreds of computers, IPs and route
                tables, frontend and backend web servers, databases, message
                queues etc... and validate that everything works well
                together.`,
            ['br'],
            ` In Hola we wanted every developer to own a complete staging
                environment of his own, so we used `,
            ['a',
                [`LXC`],
                {href: `https://linuxcontainers.org`},
            ],
            ` technology to power it.`,
            ['br'],
            ` In a single command we manage to start up in `,
            ['b',
                [`under 6 seconds`],
            ],
            ` a full emulation of hundreds of NodeJS/C/C++ based servers
                with different IP addresses and complex route tables,
                multiple MongoDB and NGINX servers, graphite, elasticsearch,
                and many other servers and services.`,
            ['br'],
            ` Now every developer can fully test the complete product,
                inside his own laptop, `,
            ['b',
                [`even before the commit`],
            ],
            ` and see how everything plays well together.`,
            ['br'],
            ` Give the developers great testing and emulation tools, and
                they will deliver great quality products.`,
            ['br'],
            ` Full description of `,
            ['code',
                [`zlxc`],
            ],
            ` can be found once running `,
            ['code',
                [`zlxc --help`],
            ],
            `, however some `,
            ['code',
                [`zlxc`],
            ],
            ` most common commands and usage are: `],
        ],
        ['ul',
            [['li',
                [['code',
                    [`zlxc run [group]`],
                ],
                ` - runs specific servers (saves booting time)`],
            ],
            ['li',
                [['code',
                    [`zlxc relink`],
                ],
                ` - relink modified files to the zlxc container`],
            ],
            ['li',
                [['code',
                    [`zlxc windows`],
                ],
                ` - runs zlxc and enable connecting external Windows VM to
                    the zlxc environment`],
            ],
            ['li',
                [['code',
                    [`cvsup -A && jmake cm release && zlxc run [group]
                        --purge`],
                ],
                ` - run an up-to-date clean zlxc instance from scratch`],
            ]],
        ]],
    },
    {
        id: 'workstation',
        title: `Workstation`,
        tag: 'h3',
        short: `Workstation`,
        html: [['p',
            [` Your work station enables you to be efficient. At Hola we
                invest a lot of efforts making it best configured and
                efficient as possible.`,
            ['br'],
            ` To keep it up-to-date, make sure to run `,
            ['a',
                [['code',
                    [`zupdate`],
                ]],
                {href: `#zupdate`},
            ],
            ` every day. It will make sure all your development tools (`,
            ['a',
                [`gvim`],
                {href: `#gvim`},
            ],
            `, `,
            ['a',
                [`zlxc`],
                {href: `#zlxc`},
            ],
            `, `,
            ['a',
                [`cvsed`],
                {href: `#cvsed`},
            ],
            `, `,
            ['a',
                [`zlint`],
                {href: `#zlint`},
            ],
            `, `,
            ['a',
                [`FastStone`],
                {href: `#capture`},
            ],
            `, etc.) and look&feel are kept configured and updated.`,
            ['br'],
            ` It could happen that you'll feel the way your workstation is
                configured is not your style, and you would like to change
                it to suit you best. You may freely change it, once you are
                `,
            ['a',
                [`fully independent`],
                {href: `#noob`},
            ],
            ` and can work on your own. Therefore, to `,
            ['a',
                [`save your colleague's time`],
                {href: `/dna#individual-mindful`},
            ],
            ` (as they are used to this environment), work with the current
                configuration and suggest any environment enhancements to
                your `,
            ['a',
                [`mentor`],
                {href: `#mentor`},
            ],
            `.`,
            ['br'],
            ` Our development tree is called `,
            ['a',
                [`zon`],
                {href: `#zon`},
            ],
            `. While the environment and tools are being installed by `,
            ['a',
                [`zupdate`],
                {href: `#zupdate`},
            ],
            ` on the `,
            ['code',
                [`.zon`],
            ],
            ` tree, you may duplicate it for development purposes to `,
            ['code',
                [`zon1`],
            ],
            ` and/or `,
            ['code',
                [`zon2`],
            ],
            `, by simply execute `,
            ['code',
                [`cp -a .zon zon1`],
            ],
            ` or `,
            ['code',
                [`cvs co -d zon2 zon`],
            ],
            `. This will give you the ability to work on one task in `,
            ['code',
                [`zon1`],
            ],
            `, while doing other tasks on `,
            ['code',
                [`zon2`],
            ],
            `.`,
            ['br'],
            ` Moreover, doing your `,
            ['a',
                [`daily`],
                {href: `#daily`},
            ],
            ` and updating your `,
            ['a',
                [`version plan`],
                {href: `#version_plan`},
            ],
            ` can be done very easily by executing `,
            ['code',
                [`cvsed daily`],
            ],
            ` (to update your daily), or `,
            ['code',
                [`cvsed vp`],
            ],
            ` to update your version plan's section, or `,
            ['code',
                [`cvsed vpd`],
            ],
            ` to update both daily and version plan at the end of the day. `],
        ]],
    },
    {
        id: 'monitor',
        title: `Monitor and alerts`,
        tag: 'h3',
        short: `Monitor`,
        html: [['p',
            [` We use graphite as the base of our monitoring and alerting
                system. We add many `,
            ['a',
                [`zcounters`],
                {href: `#zcounter`},
            ],
            ` in our code to send stats to our servers, and aggregate them
                up on a realtime monitoring and alerting dashboard. That's
                how we keep our services up and running 24/7/365. `],
        ]],
    },
    {
        id: 'zcounter',
        title: `zcounter: monitor your code`,
        tag: 'h3',
        short: `zcounter`,
        html: [['p',
            [` To validate your code runs well in the real world, add
                zcounters inside your code - count and measure events, and
                use our `,
            ['a',
                [`graphite based dashboard`],
                {href: `#monitor`},
            ],
            ` to monitor their values, and alert when something goes wrong.
                `],
        ]],
    },
    {
        id: 'perr',
        title: `perr: collect errors and other reports`,
        tag: 'h3',
        short: `perr`,
        html: [['p',
            [` The idea of "perr" was so that clients (initially is was for
                Hola Accelerator) could submit crashes and other runtime
                errors. Submission of perr reports is open to the outside
                world, and the system is built to handle a very large
                incoming flow. `],
        ],
        ['p',
            [` These days, the technology has been repurposed to collect
                reports about events other than errors, too. For instance,
                our browser extensions, Android apps etc send reports on
                events such as "authentication", "first use" and so on. `],
        ],
        ['p',
            [` The perr servers receive these reports over HTTP. Then they do
                several things: `],
        ],
        ['ol',
            [['li',
                [` Report `,
                ['a',
                    [`zcounters`],
                    {href: `#zcounter`},
                ],
                ` about certain types of perr or their properties. Most, if
                    not all, perr types produce a zcounter `,
                ['code',
                    [`stats.glob.perr.$ID`],
                ],
                ` just to count them. Also, CDN reports produce many
                    zcounters that are specific to particular
                    customers/zones, based on individual events mentioned in
                    the report. In fact, most of the CDN world in the
                    dashboard is produced this way by the perr servers. `],
            ],
            ['li',
                [` Drop certain reports. The server can be configured to drop
                    reports according to specific rules. This is done so
                    that the database does not get flooded with millions of
                    identical reports when we only need a few to diagnose
                    problems. Note that the zcounter submission above
                    happens before the dropping. `],
            ],
            ['li',
                [` Forward remaining reports to the database where their
                    bodies will be stored. `],
            ]],
        ]],
    },
    {
        id: 'perr-visualization',
        title: `perr data
  visualization`,
        tag: 'h4',
        short: `perr visualization`,
        html: [['p',
            [` ElasticSearch is the specialized database to which the perr
                service submits the reports on step 3 above. In fact, the
                full data flow is like this: `],
        ],
        ['p',
            [['code',
                [` (client) -> zs-client-*-f -> zs-perr-*-b -> zs-log ->
                    zs-elasticsearch -> (kibana) `],
            ]],
        ],
        ['p',
            [` (The zs-log server does little more than just forward the
                reports. These days, its presence is mostly historical.) `],
        ],
        ['p',
            [` Kibana is a web application that lets you explore the
                ElasticSearch database. It is to ElasticSearch what our
                dashboard is to metricdb. `],
        ]],
    },
    {
        id: 'deploy',
        title: `Deploy: shipping your code to millions of
  users`,
        tag: 'h3',
        short: `Deploy`,
        html: [['p',
            [` Deployment is putting your work out for everyone to use. The
                deploy team will take your request, and will follow a
                detailed procedure that will label, test and eventually
                release your code.`,
            ['br'],
            ` If an issue occurs during this process, the deploy team will
                notify you - so you will be able to quickly fix it.`,
            ['br'],
            ` The deploy team is available to receive your requests and is
                responsible for `,
            ['a',
                [`monitoring dashboard`],
                {href: `http://dashboard.hola.org`,
                    'data-toggle': `tooltip`,
                    'data-placement': `top`,
                    title: ``,
                    'data-original-title': `Link to internal Hola site (not public).`},
            ],
            ` 24/7/365 `],
        ]],
    },
    {
        id: 'bootcamp',
        title: `
  
  Bootcamp: your first days at Hola
`,
        tag: 'h3',
        short: `Bootcamp`,
        html: [['p',
            [` A `,
            ['a',
                [`3 week training program`],
                {href: `/dna/bootcamp`},
            ],
            `, in which you are introduced to the way we work, communicate
                and collaborate with each other.`,
            ['br'],
            ` It's time to learn! and adopt our `,
            ['a',
                [`DNA`],
                {href: `/dna`},
            ],
            `, as well as perform your profession skills.`,
            ['br']],
        ]],
    },
    {
        id: 'noob',
        title: `
  
  Hola Noob: start doing real stuff, but still a lot of questions
`,
        tag: 'h3',
        short: `Hola Noob`,
        html: [['p',
            [` Larger tasks, significant contribution while actively learning
                about the company's DNA, software architectures and work
                methods. `,
            ['a',
                [`Code reviews`],
                {href: `/dna/dict#review-sync`},
            ],
            ` for most commits, some `,
            ['a',
                [`without a pre-commit review session`],
                {href: `/dna/dict#review-async`},
            ],
            `, and sometimes even only after deployment. `],
        ]],
    },
    {
        id: 'junior',
        title: `
  
  Hola Junior: on your way to being part of the family!
`,
        tag: 'h3',
        short: `Hola Junior`,
        html: [['p',
            [` A major contributor to Hola's products, developing specific
                domain knowledge in fields that are of interest to you
                within Hola. Commit directly to the product tree without
                prior review, and see your contributions going live to
                millions of users within hours of being developed. Still
                internalizing Hola's DNA and best practices, and open to
                comments about commits from other Hola Veterans. `],
        ]],
    },
    {
        id: 'veteran',
        title: `
  
  Hola Veteran: A 'did-it-all' Veteran at Hola
`,
        tag: 'h3',
        short: `Hola Veteran`,
        html: [['p',
            [` An integral part of the Hola Family. A major contributor,
                knowledge center, and a person who can help Noobs and
                Juniors get up to speed on the Hola DNA and best practices
                through `,
            ['a',
                [`mentoring`],
                {href: `/dna/dict#mentor`},
            ],
            `, and `,
            ['a',
                [`code reviews`],
                {href: `/dna/dict#review`},
            ],
            `. `],
        ]],
    },
    {
        id: 'chef',
        title: `Hola Chef`,
        tag: 'h3',
        short: `Hola Chef`,
        html: [['p',
            [` We truly believe that eating healthy and good food should be
                part of having fun at work, while being creative and
                productive when creating fantastic products!`,
            ['br'],
            ` Our in-house chefs are responsible for those great meals we
                have every day. `],
        ]],
    },
    {
        id: 'mentor',
        title: `Mentor: Your Hola veteran buddy`,
        tag: 'h3',
        short: `Mentor`,
        html: [['p',
            [` The Hola mentors are selected `,
            ['a',
                [`Veterans`],
                {href: `#veteran`},
            ],
            ` that embody the Hola DNA and have the ability to help `,
            ['a',
                [`Noobs`],
                {href: `#noob`},
            ],
            ` learn to become great contributing team members.`,
            ['br'],
            ` Every Noob is assigned a mentor -- a Veteran who helps to
                progress from `,
            ['a',
                [`noob`],
                {href: `#noob`},
            ],
            ` to `,
            ['a',
                [`junior`],
                {href: `#junior`},
            ],
            ` to `,
            ['a',
                [`veteran`],
                {href: `#veteran`},
            ],
            ` status. It's up to you, the Noob, to get as much face time
                with the Veteran and ask any question, so that you can learn
                as much as possible. The Mentor is busy with his tasks, but
                will take the time to help you as much as you need when you
                ask for it.`,
            ['br'],
            ` What's the best way to learn from a mentor? One very effective
                way is plain old imitation -- looking at his practices,
                daily routines, time and task management, email styling, at
                how he communicates with colleagues. These are all great
                practices to take on until you create your own style at
                Hola. `],
        ],
        ['ul',
            [['li',
                [` At `,
                ['a',
                    [`Bootcamp`],
                    {href: `#bootcamp`},
                ],
                ` stage mentor helps how to find what is necessary for
                    fulfilling tasks: documentation, code, people. He also
                    reviews your code. `],
            ],
            ['li',
                [`Mentor of a `,
                ['a',
                    [`Noob`],
                    {href: `#noob`},
                ],
                ` helps learning company's DNA, and still does the code
                    reviews.`],
            ],
            ['li',
                [`Mentor of a `,
                ['a',
                    [`Junior`],
                    {href: `#junior`},
                ],
                ` is a go-to person to understand how the company and
                    procedures work in detail.`],
            ]],
        ]],
    },
    {
        id: 'mvp',
        title: `MVP: Minimal Viable Product`,
        tag: 'h3',
        short: `MVP`,
        html: [['p',
            [` In any task/feature/product we build at Hola, we try to
                progress incrementally, by building a Minimal Viable Product
                (or minimal viable task/feature) that brings value to the
                end user. This allows testing whether the solution is in the
                right direction. It also brings immediate value to the end
                user, or if it is an internal task - brings an immediate
                solution to a real problem. If the MVP works out well,
                additional incremental improvements will be done. If not, a
                different direction (thus a different MVP) will be tried out
                to solve the same problem.`,
            ['br'],
            ` This is a core concept in modern `,
            ['a',
                [`Lean Startups`],
                {href: `http://theleanstartup.com/principles`},
            ],
            `. We highly recommend you read `,
            ['b',
                [`The Lean Startup`],
            ],
            ` book. See also `,
            ['a',
                [`Wiki`],
                {href: `https://en.wikipedia.org/wiki/Minimum_viable_product`},
            ],
            `. `],
        ]],
    },
    {
        id: 'zon',
        title: `ZON: appears in the code - but what is it?`,
        tag: 'h3',
        short: `Zon`,
        html: [['p',
            [` Hola was founded in 2008, and sticking to the `,
            ['a',
                [`MVP`],
                {href: `#mvp`},
            ],
            ` method, our 0.1 version of the company name was ZON. This gave
                us time to find a name that best represents our values:
                simplicity, directness, friendly, welcoming. By the
                beginning of 2009 we found it: "Hola", coupled with is
                friendly smiley :-)`,
            ['br'],
            ` So our source tree directory is still '.zon', and our internal
                tools and functions many times have a 'z' prefix, and our
                P2P protocol is called zmsg. `],
        ]],
    },
    {
        id: 'coding',
        title: `Coding conventions (Style Guides)`,
        tag: 'h3',
        short: `Coding conventions`,
        html: [['p',
            [` Source Code is the main produce of software developers. It's
                most of what we read and write at all day - even more than
                the time we spend reading and writing emails (... we also
                have `,
            ['a',
                [`email style guide`],
                {href: `/dna/comm#email`},
            ],
            ` to make them consistent!)`,
            ['br'],
            ` It's the main form of communication between the team, and
                therefore its consistency is highly important.`,
            ['br'],
            ` Having our codebase perfectly consistent in style makes it
                easy for developers to read and modify each other's code. We
                try to express our individuality and personal great
                engineering skills, not by spacing and indenting our code
                differently than others, rather by finding simple solutions
                to complex problems, great algorithms, original and
                efficient designs.`,
            ['br'],
            ` There's no 'right' or 'wrong' in coding conventions - any
                coding convention chosen can be 'right', as long as it
                exists, and is strictly followed by all of us - thus
                achieving consistency. `],
        ],
        ['ul',
            [['li',
                [['a',
                    [`Tree structure`],
                    {href: `/dna/tree_code`},
                ]],
            ],
            ['li',
                [['a',
                    [`JS`],
                    {href: `/dna/js_code`},
                ]],
            ],
            ['li',
                [['a',
                    [`CSS`],
                    {href: `/dna/css_code`},
                ]],
            ],
            ['li',
                [['a',
                    [`HTML`],
                    {href: `/dna/html_code`},
                ]],
            ],
            ['li',
                [['a',
                    [`C/C++`],
                    {href: `/dna/c_code`},
                ]],
            ],
            ['li',
                [['a',
                    [`Perl`],
                    {href: `/dna/perl_code`},
                ]],
            ],
            ['li',
                [['a',
                    [`Java`],
                    {href: `/dna/java_code`},
                ]],
            ],
            ['li',
                [['a',
                    [`C#`],
                    {href: `/dna/cs_code`},
                ]],
            ],
            ['li',
                [['a',
                    [`Shell`],
                    {href: `/dna/shell_code`},
                ]],
            ],
            ['li',
                [['a',
                    [`Google Sheets/Excel`],
                    {href: `/dna/sheet_code`},
                ]],
            ]],
        ]],
    },
    {
        id: 'email',
        title: `Email`,
        tag: 'h3',
        short: `Email`,
        html: [['p',
            [` Emails is our primary way of communicating within the team, as
                we appreciate each other's time.`,
            ['br'],
            ` We use it to discuss issues offline, to notify about code
                modifications (`,
            ['a',
                [`jdoc`],
                {href: `#jdoc`},
            ],
            `), as well as provide tasks to each other and share useful
                information.`,
            ['br'],
            ` Since this interface is central to the way we work, just like
                with `,
            ['a',
                [`coding conventions`],
                {href: `#coding`},
            ],
            `, we also adopted an `,
            ['a',
                [`email style guide`],
                {href: `/dna/comm#email`},
            ],
            ` to speak the same language, and be more efficient while
                handling it as part of our regular tasks. `],
        ]],
    },
    {
        id: 'version_plan',
        title: `version_plan: Open planning for the
  near and far future`,
        tag: 'h3',
        short: `version_plan`,
        html: [['p',
            [` The version plan can be found in `,
            ['code',
                [`doc/design/version_plan.txt`],
            ],
            `.`,
            ['br'],
            ` Each engineer will have a section with his login and username,
                holding his future and current tasks. The version plan holds
                the R&D planned tasks. It is the engineer's responsibility
                to update his progress in this file once a day.`,
            ['br'],
            ` Updating this file can be done easily with `,
            ['a',
                [`cvsed`],
                {href: `#cvsed`},
            ],
            `. Writing guidelines can be found in the `,
            ['a',
                [`Version plan code`],
                {href: `/dna/plan_code#vp`},
            ],
            `. `],
        ]],
    },
    {
        id: 'daily',
        title: `daily: Open reporting of daily achievements`,
        tag: 'h3',
        short: `Daily`,
        html: [['p',
            [` Your daily file is a text file, located under your name in `,
            ['code',
                [`.zon/doc/report`],
            ],
            ` directory.`,
            ['br'],
            ` The goal of this file is to report your daily achievements,
                describe your commitment (tasks you will complete for sure
                in the next day) and state your next planned task/s (tasks
                your are about to start after completing your commitment).`,
            ['br'],
            ` This daily report, makes our development `,
            ['a',
                [`transparent`],
                {href: `/dna#transparentall`},
            ],
            ` and let everybody understand what everybody does, as well as
                let everybody comment or suggest what is best to do next
                (you may use the `,
            ['a',
                [`NOTIFY`],
                {href: `/dna/dict#jdoc`},
            ],
            ` to let specific people know about your progress).`,
            ['br'],
            ` Updating this file is done every day, usually at the end of it
                (you may choose to update it at the beginning of the work
                day, summarizing your previous working day) using our `,
            ['a',
                [`cvsed`],
                {href: `#cvsed`},
            ],
            ` tool.`,
            ['br'],
            ` What should be reported?`,
            ['br'],
            ` In general, every task that took you more than half a day,
                should be reported.`,
            ['br'],
            ` What kind of tasks should I report?`,
            ['br'],
            ` The file actually describes your working progress, according
                to the plan described in `,
            ['a',
                [`version_plan.txt`],
                {href: `#version_plan`},
            ],
            `. Writing guidelines can be found in the `,
            ['a',
                [`Daily code`],
                {href: `/dna/plan_code#daily`},
            ],
            `. `],
        ]],
    },
    {
        id: 'prod_weekly',
        title: `Product weekly report`,
        tag: 'h3',
        short: `Product weekly report`,
        html: [['p',
            [` A weekly executive summary, generated by product or project
                owners, to their team, managers and stake holders, to be
                send by the end of the week, spreading the news about weekly
                accomplishments.`,
            ['br'],
            ` What should be reported?`,
            ['br'],
            ` In general, every achievement accrued and completed during the
                last week (with respect to a specific
                product/responsibility) should be reported as well as
                relating to the activities and goals to be carried out the
                following week.`,
            ['br'],
            ` Be `,
            ['a',
                [`precise`],
                {href: `/dna#transparent-precise`},
            ],
            `. Write down numbers. Compare to previous weeks and explain the
                growth/regression, success/failure. `],
        ],
        ['pre',
            [`Was a great week: we reached 95% success rate in install flow, so
our installs improved dramatically.
we have many ideas we will work on next week to continue improving it.
Also the homepage changes helped to get the numbers up.
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`Improved number of downloads on hola homepage
as a result of improving the user flow during installation.
Completed:
+ web installer - increase the installs from 65% to 95% by
  fixing technical bugs during installation flow.
Planned:
* Design and implement the main view in hola homepage to increase the first
  click on the main button from 35% to 70% (attached first version of the
  new design.  we will run a test during the weekend).
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'online',
        title: `Online`,
        tag: 'h3',
        short: `Online`,
        html: [['p',
            [` The working hours of everyone, including management, are all
                open for the whole company to see - enabling real time peer
                collaboration.`,
            ['br'],
            ` This allows the company's R&D to be spread out in 20+ cities,
                over 15 time zones, and still be an efficient and productive
                development team. `],
        ]],
    },
    {
        id: 'products',
        title: `The Hola product lines`,
        tag: 'h3',
        short: `Products`,
        html: [['ul',
            [['li',
                [`Hola `,
                ['a',
                    [`hola.org`],
                    {href: `http://hola.org`},
                ]],
            ],
            ['ul',
                [['li',
                    [`Value: Making the web worldwide again by allowing
                        everyone the freedom to watch content`],
                ],
                ['li',
                    [`Tech: Its the only P2P network in the world.
                        P2P makes Hola free and open`],
                ],
                ['li',
                    [`Platforms: Available as a Chrome Extension, Firefox
                        Extension, stand-alone browser, iOS, Android`],
                ]],
            ]],
        ]],
    },
    {
        id: 'dna_mgr',
        title: `DNA Manager`,
        tag: 'h3',
        short: `DNA Manager`,
        html: [['p',
            [` Hola is a `,
            ['a',
                [`DNA company`],
                {href: `/dna#dna`},
            ],
            ['br'],
            ` To keep our DNA, which is critical to our success, the DNA
                manager overlooks all activities in the company, and makes
                sure they are compliant with our DNA, which we all
                participated in creating.`,
            ['br'],
            ` This includes activities such as: `],
        ],
        ['ul',
            [['li',
                [['a',
                    [`version plan`],
                    {href: `#version_plan`},
                ]],
            ],
            ['li',
                [['a',
                    [`daily`],
                    {href: `#daily`},
                ],
                ` report`],
            ],
            ['li',
                [`attendance: hours, vacations, leave, sick, holiday...`],
            ],
            ['li',
                [['a',
                    [`emails and communications`],
                    {href: `/dna/comm`},
                ]],
            ],
            ['li',
                [`R&D and Deploy shifts`],
            ],
            ['li',
                [`DNA training sessions in `,
                ['a',
                    [`bootcamp`],
                    {href: `/dna/bootcamp`},
                ]],
            ],
            ['li',
                [['a',
                    [`Hola ranks`],
                    {href: `/dna#dna-team-veteran`},
                ]],
            ],
            ['li',
                [`... and generally looking out for any deviation from our
                    DNA`],
            ]],
        ]],
    },
    {
        id: 'attendance',
        title: `Attendance`,
        tag: 'h3',
        short: `Attendance`,
        html: [['p',
            [` At Hola you may choose to work from any location you prefer to
                be as productive and effective as you can.`,
            ['br'],
            ` We find that working in the office with your peers is
                typically the most productive environment and most fun to
                work at. This is the reason we have several offices
                worldwide, allowing our employees to spend their day with
                their peers. So while working from our offices, we usually
                work for 9.5 hours a day (working hours are usually
                09:00-18:30), out of which 30 minutes is our `,
            ['a',
                [`lunch break`],
                {href: `#chef`},
            ],
            `. Minimum working day is usually 4-5h a day.`,
            ['br'],
            ` But some of us live far from the office or in countries where
                Hola does not have an office and so must work from `,
            ['a',
                [`home (cloud office)`],
                {href: `/dna/cloud`},
            ],
            `. `],
        ]],
    },
    {
        id: 'attendance-report',
        title: `Reporting attendance`,
        tag: 'h4',
        html: [['p',
            [` We have several interfaces to report attendance: `],
        ],
        ['ul',
            [['li',
                [['b',
                    [`attendance clock`],
                ],
                ['br'],
                ` When working from the office, use your card or your
                    fingerprint on the attendance clock, at the entrance, to
                    login / logout upon entering and leaving the office. `],
            ],
            ['li',
                [['b',
                    [`web`],
                ],
                ['br'],
                ['a',
                    [`Timesheet`],
                    {href: `https://web.hola.org/att`,
                        'data-toggle': `tooltip`,
                        'data-placement': `top`,
                        title: ``,
                        'data-original-title': `Link to internal Hola site (not public).`},
                ],
                ` web interface (requires VPN connection), which enables you
                    to login and logout while defining your work location: `,
                ['ul',
                    [['li',
                        [['dfn',
                            [`At home`],
                        ],
                        ` - When working from home or hotel`],
                    ],
                    ['li',
                        [['dfn',
                            [`In Office`],
                        ],
                        ` - When working from Hola's office only if the
                            attendance clock is not working or available `],
                    ],
                    ['li',
                        [['dfn',
                            [`On Road`],
                        ],
                        ` - Used by sales people, going to meetings outside
                            their home or hotel `],
                    ]],
                ]],
            ],
            ['li',
                [['b',
                    [`email`],
                ],
                ` (sales team only)`,
                ['br'],
                ` Send an email to `,
                ['code',
                    [`login@hola.org`],
                ],
                ` with your location in the subject (`,
                ['code',
                    [`home`],
                ],
                `, `,
                ['code',
                    [`office`],
                ],
                `, `,
                ['code',
                    [`meeting`],
                ],
                `, `,
                ['code',
                    [`on the road`],
                ],
                `...): `,
                ['div',
                    [['span',
                        [['span',
                            [`From:`],
                            {className: `email-tag`},
                        ],
                        ` nir@hola.org`],
                        {className: `email-tag-line`},
                    ],
                    ['br'],
                    ['span',
                        [['span',
                            [`To:`],
                            {className: `email-tag`},
                        ],
                        ` login@hola.org`],
                        {className: `email-tag-line`},
                    ],
                    ['br'],
                    ['span',
                        [['span',
                            [`Subject:`],
                            {className: `email-tag`},
                        ],
                        ` meeting`],
                        {className: `email-tag-line`},
                    ],
                    ['br']],
                    {className: `email has-popover`,
                        cat: `good`,
                        'data-content': `GOOD`,
                        'data-original-title': ``,
                        title: ``},
                ],
                ` to logout, send: `,
                ['div',
                    [['span',
                        [['span',
                            [`From:`],
                            {className: `email-tag`},
                        ],
                        ` nir@hola.org`],
                        {className: `email-tag-line`},
                    ],
                    ['br'],
                    ['span',
                        [['span',
                            [`To:`],
                            {className: `email-tag`},
                        ],
                        ` logout@hola.org`],
                        {className: `email-tag-line`},
                    ],
                    ['br']],
                    {className: `email has-popover`,
                        cat: `good`,
                        'data-content': `GOOD`,
                        'data-original-title': ``,
                        title: ``},
                ]],
            ],
            ['li',
                [['b',
                    [`command line`],
                ],
                ['br'],
                ['code',
                    [`daily login`],
                ],
                ` / `,
                ['code',
                    [`daily logout`],
                ],
                ` - which enable you to login and logout respectively from
                    within your Ubuntu VM (usually being used by the R&D) `],
            ]],
        ]],
    },
    {
        id: 'attendance-absence',
        title: `Reporting absence`,
        tag: 'h4',
        html: [['p',
            [` If you have a planned absence - report it in advance on your `,
            ['a',
                [`daily`],
                {href: `#daily`},
            ],
            ` report. Unplanned absence (e.g. sick leave) should be reported
                on the daily report as well.`,
            ['br'],
            ` If you plan to work less hours a day for a given period of
                time, notify your manager - to set expectation of your
                progress correctly. Your daily report for such days should
                also indicate it. `],
        ]],
    },
    {
        id: 'suggest',
        title: `Suggest`,
        tag: 'h3',
        short: `Suggest`,
        html: [['p',
            [` When making an improvement suggestion, whether of an internal
                tool or of a new design to replace an existing one, the
                suggestion needs to be well thought of before. The
                responsibility for thinking it out over, and bringing
                well-prepered suggestions are on the one who is suggesting
                it.`,
            ['br'],
            ` The `,
            ['a',
                [`cost-effectiveness`],
                {href: `/dna#effective-cost`},
            ],
            ` of the proposed solution should be the main factor. `],
        ]],
    },
    {
        id: 'suggest-checklist',
        title: `Suggestion checklist`,
        tag: 'h4',
        short: `Suggestion checklist`,
        html: [['ul',
            [['li',
                [`How much time is spent today due to the existing design?`],
            ],
            ['li',
                [`How much time will be saved after the implementation?`],
            ],
            ['li',
                [` How much Total Cost Ownership is the change (preparing
                    suggestion, discussion time, agreeing on it, coding,
                    debugging, deploying, finding all the edge cases)? `],
            ],
            ['li',
                [`Do we lose any features? Are you fully aware that these
                    features are not required?`],
            ],
            ['li',
                [`Do you have a full idea on how to implement it, on all its
                    technical aspects and details, and there are no 'black
                    holes'?`],
            ],
            ['li',
                [`What are the cheaper/quicker ways to solve the same
                    problem?`],
            ]],
        ]],
    },
];
return E;
});
